import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './CancelComponent.module.scss';
import ButtonSimple from '../HeroBlockBlog/components/ButtonSimple/ButtonSimple';
import FooterButton from '../Footer/components/FooterButton/FooterButton';

export type CancelType = {
  className?: string;
};

const Cancel: NextPage<CancelType> = ({ className = '' }) => {
  return (
    <section className={styles.paid}>
      <div className="container">
        <div className={[styles.paid1440px, className].join(' ')}>
          <section className={styles.block}>
            <Image
              className={styles.logoIcon}
              loading="lazy"
              width={108}
              height={108}
              sizes="100vw"
              alt=""
              src="/img/modal/error-logo.webp"
            />
            <div className={styles.text}>
              <div className={styles.name}>
                Unfortunately it was not possible to pay for the flight.
              </div>
              <h3 className={styles.name1}>
                We&apos;re sorry, an error occurred while processing your
                payment for your Hera Flight flight. Please try to make the
                payment again, carefully checking that all the details are
                correct.
                <br />
                <br />
                If the problem persists, please contact us - we will be happy to
                help you sort it out!
              </h3>
            </div>
          </section>
          <div className={styles.buttongroup}>
            <ButtonSimple
              className={styles.submitButton}
              color="accent"
              highContrast
              loading={false}
              size={3}
              state="default ✦"
              variant="solid ✦"
              text="Go to Homepage"
              iconStart={false}
              iconEnd={false}
              focusRing={false}
              designBlendingMode="/design--blendingmode1.svg"
              designBlendingMode1="/design--blendingmode1.svg"
              href="/"
            />
            <FooterButton
              className={styles.footerButton}
              color="accent"
              highContrast={false}
              loading={false}
              size={3}
              state="default ✦"
              variant="solid ✦"
              text="Contact Us"
              iconStart={false}
              iconEnd={false}
              focusRing={false}
              border1={true}
              href="/contact/"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cancel;
